import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#32A9FF",
			d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M7.998 8.395 3.781 6.29v4.18a.802.802 0 0 0 .8.8h6.838a.802.802 0 0 0 .8-.8V6.335l-4.22 2.06Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m8.002 7.604 4.217-2.058v-.018a.802.802 0 0 0-.8-.8H4.581a.802.802 0 0 0-.8.771l4.22 2.105Z"
		})
	]
});
const ForwardRef = forwardRef(SvgEmailmin);
export { ForwardRef as ReactComponent };
